import { createAction } from 'redux-actions';
import debounce from 'debounce-promise';

import reportError from 'ha/helpers/bugsnag/reportError';

import { getPreviewRequestId } from '../selectors';
import { Actions, PreviewNumberOfListingsDebounceMs } from '../constants';
import { getAlgoliaListingsQuery } from '../utils';
import updateSearch from './updateSearch';
import loadCurrencyRates from './loadCurrencyRates';

export const flow = {
  start: createAction(Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_START),
  done: createAction(Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_DONE),
  error: createAction(Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_ERROR),
};

const debouncedSearchListings = debounce(
  (algolia, queries) =>
    algolia.searchListings(queries).then(response => response.results),
  PreviewNumberOfListingsDebounceMs,
);

export default reqParams => (dispatch, getState, services) => {
  const requestId = Date.now();

  dispatch(flow.start(requestId));

  return Promise.all([dispatch(updateSearch()), dispatch(loadCurrencyRates())])
    .then(([searchParams, { data: { rates } }]) =>
      debouncedSearchListings(services.algolia, [
        getAlgoliaListingsQuery(reqParams, searchParams, rates, {
          withoutData: true,
        }),
      ]),
    )
    .then(algoliaResponses => {
      const [listings] = algoliaResponses;

      if (getPreviewRequestId(getState()) !== requestId) {
        // Query is not the last one. Dismiss results.
        return;
      }

      dispatch(
        flow.done({
          total: listings.nbHits,
        }),
      );
    })
    .catch(error => {
      reportError(error);
      if (getPreviewRequestId(getState()) !== requestId) {
        // Query is not the last one. Dismiss results.
        return;
      }
      dispatch(flow.error());
    });
};
